import React from 'react';

import { Link } from 'react-router';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';

import { namespace, actions, selectors } from './';

import wrapMain from '../../wrap-main';

import TextField from '../../../shared/form-elements/textarea';
import { isRequired } from '../../../shared/form/validation';

function Editor({ intl, languages, ...props }) {
	return (
		<div className='form-container'>
			<div className='form-container__head'>
				<h2 className='icon-edit'>
					{intl('edit article comment')}
				</h2>
			</div>
			<div className='form-container__body'>
				<form onSubmit={props.handleSubmit}>
					<Field
						name='text'
						component={TextField}
						validate={[isRequired]}
						placeholder={intl('Text')}
					/>
					<div className='banners-buttons'>
						<button className='ui-btn ui-btn-primary'>
							{intl('Save')}
						</button>
						<Link
							className='ui-btn ui-btn-cancel'
							to='/blog/article-comments'
						>
							{intl('Cancel')}
						</Link>
					</div>
				</form>
			</div>
		</div>
	);
}

function mapStateToProps(state) {
	return {
		initialValues: selectors.select(state, 'data'),
		isLoading: selectors.select(state, 'isLoading'),
		isError: selectors.select(state, 'isError')
		// -----------------------------------------
	};
}

const Main = reduxForm({ form: `${namespace}Form`, enableReinitialize: true })(Editor);

export default connect(mapStateToProps, actions.own)(wrapMain(Main));


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/blog/article-comment/editor/main.js